import React from "react";
import { Box } from "@mui/material";
import DndItem from "./DndItem";
import BaseSchedulesMenu from "./BaseSchedulesMenu";

const SchedulesMenu = ({
  schedules,
  allSchedules,
  isFetching,
  onAddSchedule,
  onOpenSchedule,
  moveSchedule,
  reorderSchedule,
  searchMode = false,
}) => {
  return (
    <BaseSchedulesMenu
      schedules={schedules}
      allSchedules={allSchedules}
      isFetching={isFetching}
      onAddSchedule={onAddSchedule}
      onOpenSchedule={onOpenSchedule}
      moveSchedule={moveSchedule}
      reorderSchedule={reorderSchedule}
      searchMode={searchMode}
      DndItemComponent={DndItem}
      buttonWrapper={Box}
      buttonWrapperProps={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    />
  );
};

export default SchedulesMenu;
